<template>
  <div>
    <!-- <van-search v-model="value" placeholder="请输入搜索关键词" @click="toPage('search')" /> -->
    <van-swipe :autoplay="3000">
      <van-swipe-item v-for="(banner, index) in bannerList" @click="toUrl(banner.url)" :key="index">
        <van-image class="swipe-img" width="100%" :src="banner.Image">
          <template #error>
            <van-image
              :src="`https://www.riceyfy.com${banner.Image}`"
              class="swipe-img"
              width="100%"
            />
          </template>
        </van-image>
      </van-swipe-item>
    </van-swipe>

    <!-- <div class="mid-nav">
      <van-grid :column-num="4" :border="false" :gutter="0">
        <van-grid-item v-for="(midNav,index) in midNavList" :key="index">
          <van-image :round="true" width="40" height="40" class="mid-nav-img" :src="midNav.Image">
            <template #error>
              <van-image
                :src="`https://www.riceyfy.com${midNav.Image}`"
                class="mid-nav-img"
                :round="true"
                width="40"
                height="40"
              />
            </template>
          </van-image>
          <div class="mid-nav-text">{{midNav.Title}}</div>
        </van-grid-item>
      </van-grid>
    </div> -->

    <van-divider :style="{ color: 'red', borderColor: 'red', padding: '0 16px' }">
      <van-icon name="fire" color="red" />
      <van-image width="60" :src="require('../../../src/assets/icons/recommend1.png')" />
    </van-divider>

    <div class="h-goods-box">
      <van-card
        class="goods"
        :key="index"
        v-for="(item, index) in recommendList"
        :price="(item.Price/100).toFixed(2)"
        :thumb="item.Image"
        :origin-price="(item.Price/100).toFixed(2)"
        :lazy-load="true"
        @click="toProduct(item.id)"
      >
        <template #title>
          <div class="info-box">
            <div>{{item.Name}}</div>
          </div>
        </template>
        <template #tags>
          <div class="soldnum-sort">
            <span>已售:{{item.SoldNum}}</span>
            <span style="padding-left:5px">剩余:{{item.Stock}}</span>
          </div>
        </template>
        <template #num>
          <van-button size="small" :color="btnColor">立即购买</van-button>
        </template>
      </van-card>
    </div>

    <div class="w-goods-box">
        
        <div
          class="item grid-item"
          :key="index"
          v-for="(item, index) in goodsList"
          @click="toProduct(item.id)"
        >
          <div class="goodsBig" @click="toProduct(item.id)">
            <van-image lazy-load :src="item.Image" />
            <div class="info-box">
              <div>{{item.Name}}</div>
              <div class="soldnum-sort">
                <span>已售:{{item.SoldNum}}</span>
                <span style="padding-left:5px">剩余:{{item.Stock}}</span>
              </div>
              <div class="price-box">
                <span class="van-card__price-currency">￥</span>
                <span class="van-card__price-integer">{{(item.Price/100).toFixed(2)}}</span>
                <van-icon class="buy-btn" name="shopping-cart" color="#ffc053" size="25" />
              </div>
            </div>
          </div>
        </div>

    </div>
  </div>
</template>

<script>
import api from "../../api/home";
import {
  Swipe,
  SwipeItem,
  Toast,
  Button,
  Search,
  Grid,
  GridItem,
  Image as VanImage,
  Tag,
  Card,
  Icon,
  Divider
} from "vant";

export default {
  components: {
    [Swipe.name]: Swipe,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Search.name]: Search,
    [VanImage.name]: VanImage,
    [GridItem.name]: GridItem,
    [Tag.name]: Tag,
    [Grid.name]: Grid,
    [Card.name]: Card,
    [SwipeItem.name]: SwipeItem,
    [Icon.name]: Icon,
    [Divider.name]: Divider
  },
  name: "home",
  props: {
    msg: String
  },
  data() {
    return {
      btnColor: "#ffc053",
      images: [
        "https://img.yzcdn.cn/vant/apple-1.jpg",
        "https://img.yzcdn.cn/vant/apple-2.jpg"
      ],
      // 搜索
      value: "",
      // 轮播图
      bannerList: [],
      recommendList: [],
      // 中间导航
      midNavList: [],
      goodsList: []
    };
  },

  created() {
    // 轮播图
    api.postList().then(res => {
      if (res.status == 0) {
        this.bannerList = res.result;
      }
    });
    // 中间导航
    api.naviList().then(res => {
      if (res.status == 0) {
        this.midNavList = res.result;
      }
    });
    // 推荐列表
    api.itemList({ Recommend: "1" }).then(res => {
      if (res.status == 0) {
        this.recommendList = res.result;
        this.recommendList.forEach(element => {
          element.ImageList
            ? (element.Image = JSON.parse(element.ImageList)[0])
            : "";
        });
      }
      console.log(res);
    });
    // 产品列表
    api.itemList().then(res => {
      if (res.status == 0) {
        this.goodsList = res.result;
        this.goodsList.forEach(element => {
          element.ImageList
            ? (element.Image = JSON.parse(element.ImageList)[0])
            : "";
        });
      }
    });
  },
  mounted() {},

  activated() {

    api.itemList({ Recommend: "1" }).then(res => {
      if (res.status == 0) {
        this.recommendList = res.result;
        this.recommendList.forEach(element => {
          element.ImageList
            ? (element.Image = JSON.parse(element.ImageList)[0])
            : "";
        });
      }
      console.log(res);
    });

    api.itemList({hideLoading:true}).then(res => {
      if (res.status == 0) {
        this.goodsList = res.result;
        this.goodsList.forEach(element => {
          element.ImageList
            ? (element.Image = JSON.parse(element.ImageList)[0])
            : "";
        });
      }
    });
  },
  methods: {
    onChange() {
      console.log(1);
    },
    // 商品页面跳转
    toProduct(id) {
      this.$router.push({
        path: "/product",
        query: {
          id: id
        }
      });
    },
    // 商品页面跳转
    toPage(name) {
      console.log(name);
      //   this.$router.push({name});
    },
    toUrl(url) {
      window.location.href = url;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.goods {
  padding: 10px;
  margin: 5px;
  background: #fff;
  border-radius: 5px;
  .van-card__thumb {
    width: 120px;
    height: 120px;
  }
}

.goods-box,
.h-goods-box {
  background-color: #f2f2f2;
  padding-top: 1px;
}
.info-box {
  width: 100%;
  font-size: 14px;
}
.w-goods-box {
  background-color: #f2f2f2;
  display: flex;
  flex-flow: row wrap;
  align-content: flex-start;
  .item {
    background: #fff;
    padding: 1%;
    margin: 0.5%;
    flex: 0 0 47%;
  }
}
.vue-waterfall-column:last-child {
  .item {
    margin-left: 0;
  }
}
/* 导航 */
.mid-nav-img {
  border-radius: 50%;
}
.mid-nav-text {
  font-size: 12px;
  padding-top: 5px;
}
.price-box {
  width: 100%;
  text-align: left;
}
.buy-btn {
  float: right;
  right: 5px;
}
.recommend-text {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.van-card__price-currency {
  font-size: 12px;
}
.van-grid-item {
  .van-grid-item__content--center {
    padding-bottom: 0px !important;
  }
}
.van-button__text {
  color: #353535;
  padding: 0 5px;
}
.soldnum-sort {
  color: #9b9b9b;
}
</style>
